import React from 'react';

import { AccountBalance, LocalAtm, CreditCard } from '@material-ui/icons';

import { MethodPayment, MethodsContainer, SvgTicket } from './styles';

const FooterPayments = () => (
  <MethodsContainer>
    <MethodPayment title="PIX">
      <SvgTicket>
        <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="/ecommerce.svg#logo-pix" />
      </SvgTicket>
      PIX
    </MethodPayment>
    <MethodPayment title="CARTÃO DE CRÉDITO">
      <CreditCard />
      CARTÃO DE CRÉDITO
    </MethodPayment>
    <MethodPayment title="BOLETO">
      <SvgTicket>
        <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="/ecommerce.svg#ticket-new" />
      </SvgTicket>
      BOLETO
    </MethodPayment>
    <MethodPayment title="DEPÓSITO">
      <LocalAtm />
      DEPÓSITO
    </MethodPayment>
    <MethodPayment title="FINANCEIRA">
      <AccountBalance />
      FINANCEIRA
    </MethodPayment>
  </MethodsContainer>
);

export default FooterPayments;
